import { Controller } from "@hotwired/stimulus"
import { renderStreamMessage } from "@hotwired/turbo"
import {
  csrfToken,
  debounce,
  deleteStream,
  patchJson,
  postStream,
  responseErrorMessage,
  sessionIdFor,
  setSaveStatus,
  updateLastSaved,
  writeFetch
} from "./sweeper_shared"

export default class extends Controller {
  toggleAdd(event) {
    const menu = this.element.querySelector("[data-resources-menu]")
    if (!menu) return
    menu.classList.toggle("hidden")
  }

  add(event) {
    const button = event.target.closest("[data-kind]")
    if (!button || !this.sessionId) return

    const menu = this.element.querySelector("[data-resources-menu]")
    if (menu) menu.classList.add("hidden")

    postStream(this.collectionUrl(), { kind: button.dataset.kind })
  }

  destroy(event) {
    const resourceId = this.resourceIdFromEvent(event)
    if (!resourceId || !this.sessionId) return
    if (!confirm("Resource verwijderen?")) return

    deleteStream(this.memberUrl(resourceId))
  }

  fieldInput(event) {
    const field = event.target.closest("[data-field]")
    if (!field) return
    const resourceId = this.resourceIdFromEvent(event)
    if (!resourceId || !this.sessionId) return

    const path = field.dataset.field
    if (path === "file") return // handled by uploadFile

    debounce(this, `resource:${resourceId}:${path}`, () => {
      // patchJson (not patchStream) so the resources frame isn't replaced
      // while the user is typing — that would steal focus from the textarea.
      patchJson(this.memberUrl(resourceId), this.buildBody(path, field.value))
    })
  }

  async uploadFile(event) {
    const field = event.target.closest('[data-field="file"]')
    if (!field || !field.files?.length) return
    const resourceId = this.resourceIdFromEvent(event)
    if (!resourceId || !this.sessionId) return

    const form = new FormData()
    form.append("file", field.files[0])

    setSaveStatus("Uploaden…")
    const response = await writeFetch(`${this.memberUrl(resourceId)}/upload_file`, {
      method: "POST",
      credentials: "include",
      headers: {
        "X-CSRF-Token": csrfToken(),
        "Accept": "text/vnd.turbo-stream.html, application/json"
      },
      body: form
    })

    if (!response.ok) {
      setSaveStatus(await responseErrorMessage(response, "Upload mislukt"), false)
      return
    }

    const contentType = response.headers.get("Content-Type") || ""
    if (contentType.includes("text/vnd.turbo-stream.html")) {
      renderStreamMessage(await response.text())
      updateLastSaved()
    }
    setSaveStatus("Geüpload", true)
  }

  buildBody(path, value) {
    // path is one of: "name", "body", "data.<key>", "data.rows.<row_id>"
    if (!path.startsWith("data.")) {
      return { [path]: value }
    }
    const segments = path.split(".").slice(1)
    let nested = value
    for (let i = segments.length - 1; i >= 0; i--) {
      nested = { [segments[i]]: nested }
    }
    return { data: nested }
  }

  resourceIdFromEvent(event) {
    const item = event.target.closest("[data-resource-id]")
    return item?.dataset.resourceId
  }

  collectionUrl() {
    return `/api/v1/sessions/${encodeURIComponent(this.sessionId)}/resources`
  }

  memberUrl(resourceId) {
    return `${this.collectionUrl()}/${encodeURIComponent(resourceId)}`
  }

  get sessionId() {
    return sessionIdFor(this.element)
  }
}
